module.exports = __webpack_public_path__ + "static/media/sspc-two.29ef57c4.png";